__webpack_require__.p = "https://assets.mindtickle.com/ui-auth/ux-refresh-prod-us-ldr/production/";